import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Alert, Card } from "react-bootstrap";

const FormAddOrder = () => {
  const [tanggalPemanenan, setTanggalPemanenan] = useState("");
  const [varietasSingkong, setVarietasSingkong] = useState("");
  const [estimasiBerat, setEstimasiBerat] = useState("");
  const [estimasiHarga, setEstimasiHarga] = useState("");
  const [hargaPerKg, setHargaPerKg] = useState({});
  const [tanamOptions, setTanamOptions] = useState([]);
  const [selectedtanam, setSelectedTanam] = useState("");
  const [msg, setMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const saveProduct = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      await axios.post(
        `https://c-greenproject.org:8000/products`,
        {
          idTanam: selectedtanam,
          tanggalPemanenan,
          varietasSingkong,
          estimasiBerat,
          estimasiHarga,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMsg("Order berhasil ditambahkan");
      setTanggalPemanenan("");
      setVarietasSingkong("");
      setEstimasiBerat("");
      setEstimasiHarga("");
      setSelectedTanam("");
      setTimeout(() => navigate("/order"), 2000);
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const responseHarga = await axios.get(
          `https://c-greenproject.org:8000/perusahaan`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const perusahaan = responseHarga.data;
        if (perusahaan.length > 0) {
          const { hargaGradeA, hargaGradeB, hargaGradeC } = perusahaan[0];
          setHargaPerKg({
            "Grade A": hargaGradeA,
            "Grade B": hargaGradeB,
            "Grade C": hargaGradeC,
          });
        }

        const responseTanam = await axios.get(
          `https://c-greenproject.org:8000/rencanatanam`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTanamOptions(responseTanam.data || []);
      } catch (error) {
        setMsg("Gagal mengambil data rencana tanam atau harga.");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchRencanaTanamData = async () => {
      if (selectedtanam) {
        const token = localStorage.getItem("token");
        try {
          const response = await axios.get(
            `https://c-greenproject.org:8000/petanisapproved`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          console.log("Full response from /petanisapproved:", response.data);
          response.data.forEach((tanam, index) => {
            console.log(`Item ${index} keys:`, Object.keys(tanam));
          });

          const tanamData = response.data
            .flatMap((tanam) => tanam.rencanaTanamInfo)
            .find((tanam) => String(tanam.idtanam) === String(selectedtanam));

          if (tanamData) {
            setTanggalPemanenan(tanamData.tanggalRencanaPanen || "");
            setVarietasSingkong(tanamData.varietassingkong || "");
            setEstimasiBerat(tanamData.estimasiproduksi || "");
          } else {
            console.log(
              "No matching data found for selectedtanam:",
              selectedtanam
            );
          }
        } catch (error) {
          setMsg("Gagal mengambil data detail rencana tanam.");
        }
      }
    };
    fetchRencanaTanamData();
  }, [selectedtanam]);

  useEffect(() => {
    if (varietasSingkong) {
      const harga = hargaPerKg[varietasSingkong] || 0;
      setEstimasiHarga(harga * estimasiBerat);
    }
  }, [varietasSingkong, hargaPerKg, estimasiBerat]);

  return (
    <Container>
      <h2 className="my-4">
        <strong>Add Order Panen</strong>
      </h2>
      {msg && <Alert variant="danger">{msg}</Alert>}
      {successMsg && <Alert variant="success">{successMsg}</Alert>}
      <Card className="p-4 mb-3 shadow">
        <Form onSubmit={saveProduct}>
          <Form.Group className="mb-3">
            <Form.Label>Pilih Rencana Tanam</Form.Label>
            <Form.Select
              value={selectedtanam}
              onChange={(e) => setSelectedTanam(e.target.value)}
            >
              <option value="">Pilih Rencana Tanam</option>
              {tanamOptions.map((tanam, index) => (
                <option key={index} value={tanam.idtanam}>
                  {`${tanam}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tanggal Panen</Form.Label>
            <Form.Control type="date" value={tanggalPemanenan} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Varietas / Jenis Singkong</Form.Label>
            <Form.Control type="text" value={varietasSingkong} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Estimasi Berat (kg)</Form.Label>
            <Form.Control type="number" value={estimasiBerat} readOnly />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Estimasi Harga (Rp)</Form.Label>
            <Form.Control type="text" value={estimasiHarga} readOnly />
          </Form.Group>

          <Button variant="success" type="submit">
            Save
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default FormAddOrder;
